import { RouteObject } from "react-router-dom";
import { dispatcherSetupRoutes } from "./dispatcher/routes";
import { settingsSetupRoutes } from "./settings/routes";
import { mxDashboardRoutes } from "./wxDashboard/routes";

import { masterSetupRoutes } from "./master";

import { wxFieldForceRoutes } from "./fieldForce/routes";


export interface wxRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: wxRoute[];
}
export const wxRoutes: wxRoute[] = [
  ...mxDashboardRoutes,
  ...wxFieldForceRoutes,
  ...dispatcherSetupRoutes,
  ...settingsSetupRoutes,
  ...masterSetupRoutes,
];
